export const handleNext = async (
  activeStep: number,
  setActiveStep: (step: number) => void,
  stepsStatus: Array<"wait" | "process" | "finish" | "error">,
  setStepsStatus: (
    step: Array<"wait" | "process" | "finish" | "error">
  ) => void,
  setBloquearBtn: (btn: boolean) => void,
  method: number,
  cadastrar: () => Promise<boolean>,
  atualizar: () => Promise<boolean>
) => {
  const updatedStatus = [...stepsStatus];
  switch (activeStep) {
    case 0:
      updatedStatus[activeStep] = "finish";
      updatedStatus[activeStep + 1] = "process";
      setStepsStatus(updatedStatus);
      setBloquearBtn(true);
      setActiveStep(activeStep + 1);

      break;

    case 1:
      updatedStatus[activeStep] = "finish";
      updatedStatus[activeStep + 1] = "process";
      setStepsStatus(updatedStatus);
      setBloquearBtn(true);
      setActiveStep(activeStep + 1);
      break;

    case 2:
      updatedStatus[activeStep] = "finish";
      updatedStatus[activeStep + 1] = "process";
      setStepsStatus(updatedStatus);

      if (method == 1) {
        atualizar();
      } else {
        cadastrar();
      }

      break;
  }
};
